import styled, {css} from 'styled-components'

export const StyledP = styled.p`
	${({theme}) => css`
		${theme.typography.textLg};
		font-weight: 400;
	`}
`
